<template>
  <div>
    <PageHeader :navigation="navigation" :alternate-languages="page.alternateLanguages" />
    <PageBody :body="body" :page="page" />
    <LazyPageFooter v-if="footer" :footer="footer" />
    <ClientOnly>
      <ReturningUserPrompt :vertical="page.context.vertical" />
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import loadPageData from './async-data'

const { navigation, footer, body, page } = await loadPageData()

usePageMeta(page)
</script>
